import Immutable from 'seamless-immutable';
import { createReducer, completeState, completeReducer } from 'redux-recompose';

import { actions } from './actions';
import { ADMINS_DEFAULT_STATE } from './constants';

const completedState = completeState(ADMINS_DEFAULT_STATE);

const reducerDescription = {
  primaryActions: [actions.ADD_ADMIN]
};

const reducer = createReducer(new Immutable(completedState), completeReducer(reducerDescription));

export default reducer;
